var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-form',{staticClass:"resend-verification",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('c-form-input',{ref:"input",attrs:{"id":"email","errors":[{
      message: 'Dieses Feld ist erforderlich.',
      show: !_vm.$v.email.required
    }, {
      message: 'Keine gültige E-Mail-Adresse.',
      show: !_vm.$v.email.email
    }],"has-error":_vm.$v.email.$error,"aria-required":"true","autocomplete":"username","label":"E-Mail-Adresse","type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('c-button',{attrs:{"busy":_vm.status === _vm.$config.status.SAVING}},[_vm._v("\n    Neuen Link anfordern\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }